import { LocationSearchResult, mapboxGeocode } from '@ljagis/react-mapping';
import { loadDitches } from 'hooks/useSearch';

export const searchLocation = (mapboxAccessToken: string, ditchUrl: string) => {
  interface DitchFeatureData {
    number: string;
    name: string;
    coordinates: [number, number];
  }

  return async (query: string): Promise<LocationSearchResult[]> => {
    const ditches = await loadDitches({ url: ditchUrl });
    const ditchResults = ditches
      .filter((ditch) =>
        `${ditch.primaryText}${ditch.secondaryText}`.toLowerCase().includes(query.toLowerCase())
      )
      .sort((a, b) => {
        if (a.primaryText < b.primaryText) return -1;
        if (a.primaryText > b.primaryText) return 1;
        return 0;
      })
      .slice(0, 5)
      .map(({ primaryText, secondaryText, coordinates }) => ({
        primaryText,
        secondaryText,
        geometry: { type: 'Point', coordinates } as GeoJSON.Point,
      }));

    const geocodeResults = await mapboxGeocode(query, mapboxAccessToken, {
      proximity: [-94.139719, 29.875426],
    });

    return [...ditchResults, ...geocodeResults];
  };
};
